import AuthService from './authService.js';

// Global record search (CD-5425). Proxied by Caspian2 GlobalSearchController to the
// OperationGlobalSearch operation in Tp_First_Micro.
class GlobalSearchService {
  // One user submit is one request. There is deliberately no debounce and no AbortController:
  // no CancellationToken is plumbed through OperationBase or HttpListenerService, so aborting a
  // stale request client-side would stop the UI using the answer but not the server producing it.
  // Every request that reaches the micro costs its full sequential fan-out either way.
  static Search(query, topN, entityTypes) {
    const authService = AuthService.getInstance();

    // clearCache=true is mandatory, not an optimisation to remove. CacheMiddleware keys the
    // response cache on the search params and ignores the user, so a cached response would serve
    // one user another user's permitted hits - and these results are RBAC-scoped per caller.
    const parameters = new URLSearchParams({
      query,
      topN: String(topN),
      clearCache: 'true',
    });

    // One repeated parameter per type, which is how ASP.NET binds a string[]. Omitted entirely when
    // nothing is scoped, so the server falls back to the query's own "Concept:" prefix or searches
    // everything the caller may see.
    (entityTypes || []).forEach((entityType) => parameters.append('entityTypes', entityType));

    // "Find", not "Search": the servers' IIS rewrites any URL matching "[a-z]+/search" to the home page.
    return authService.CallBackendFunction(`api/GlobalSearch/Find?${parameters.toString()}`);
  }

  // The scopes this user may narrow a search to, for the palette's type chips. Fetched once per
  // session and shared: the list is role-dependent but does not change while the user is logged in,
  // and chips are needed the moment the palette opens.
  static conceptsPromise = null;

  static GetConcepts() {
    if (!GlobalSearchService.conceptsPromise) {
      const authService = AuthService.getInstance();

      GlobalSearchService.conceptsPromise = authService
        .CallBackendFunction('api/GlobalSearch/Concepts?clearCache=true')
        .catch((error) => {
          // Evict on failure so the next palette open retries instead of caching the rejection.
          GlobalSearchService.conceptsPromise = null;
          throw error;
        });
    }

    return GlobalSearchService.conceptsPromise;
  }
}

export default GlobalSearchService;
